/**
 * Get market id in FullBetSlip format
 * @param {Market} market market to process
 * @return {string} id
 */
export const getMarketId = (market) => {
    if (!market || !market.id) {
        return "";
    }
    let a = market.id.match("^[1-3]_");
    if (a) {
        return market.id.slice(2, market.id.length);
    }
    return market.id;
};
//# sourceMappingURL=getMarketId.js.map